import { EbpTypeformType, IObject } from '@packages/core-shared';
import { and, collection, orderBy, query, where } from 'firebase/firestore';
import { useMemo } from 'react';
import { useSubscribeFirestoreList } from '../../hooks/useSubscribeFirestoreList';
import { useFirebase } from '../../context';

export function useSubscribeTypeforms<
  TDoc extends IObject.Timestamped<unknown>,
  TResult extends TDoc = TDoc,
>({
  patientEmail,
  formType,
}: {
  patientEmail?: string | null;
  formType: EbpTypeformType;
}) {
  const { firestore } = useFirebase();

  const queryResult = useMemo(() => {
    let q = query(
      collection(firestore, 'forms'),
      and(
        where('hidden_email', '==', patientEmail ?? '__NON_EXISTING_EMAIL__'),
        where('formType', '==', formType),
      ),
      orderBy('createdAt', 'desc'),
    );
    return q;
  }, [firestore, patientEmail, formType]);

  const loadFirestoreList = useSubscribeFirestoreList<TDoc, TResult>(
    queryResult,
  );
  return loadFirestoreList;
}
